import { render, staticRenderFns } from "./LayoutSelection.vue?vue&type=template&id=2074e633&scoped=true"
import script from "./LayoutSelection.vue?vue&type=script&lang=js"
export * from "./LayoutSelection.vue?vue&type=script&lang=js"
import style0 from "./LayoutSelection.vue?vue&type=style&index=0&id=2074e633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2074e633",
  null
  
)

export default component.exports